import {
  ModIconButton,
  ModTooltip
} from '@moderneinc/design-system-components';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { bindToggle } from 'material-ui-popup-state/hooks';
import React, { type FunctionComponent, useEffect } from 'react';
import {
  topNavIconButtonActiveSx,
  topNavIconButtonSx
} from '../../../constants/sx';
import { useManagedPopoverState } from '../../../hooks/use-managed-popover-state.hook';
import { useMenuTriggerTooltip } from '../../../hooks/use-menu-trigger-tooltip.hook';
import { KebabMenuIcon } from '../../../icons/icons';
import { OverflowMenuContent } from './overflow-menu-content.component';

export const GlobalNavigationPopover: FunctionComponent = () => {
  const popoverState = useManagedPopoverState({
    popupId: 'nav-menu-global'
  });
  const close = popoverState.close;
  const tooltipProps = useMenuTriggerTooltip(popoverState.isOpen);

  const theme = useTheme();
  const isMdOrLarger = useMediaQuery(theme.breakpoints.up('md'));

  const { isOpen } = popoverState;

  useEffect(() => {
    if (isMdOrLarger && isOpen) {
      close();
    }
  }, [isMdOrLarger, isOpen, close]);

  return (
    <React.Fragment>
      <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
        <ModTooltip title="Navigation menu" {...tooltipProps}>
          <ModIconButton
            {...bindToggle(popoverState)}
            aria-label="Navigation menu"
            variant="nav"
            active={popoverState.isOpen}
            sx={
              popoverState.isOpen
                ? topNavIconButtonActiveSx
                : topNavIconButtonSx
            }
          >
            <KebabMenuIcon />
          </ModIconButton>
        </ModTooltip>
      </Box>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={close}
        sx={{ zIndex: (theme) => theme.zIndex.snackbar }}
        slotProps={{
          paper: {
            sx: {
              width: 340,
              maxWidth: '100vw',
              // dvh tracks the visible viewport as the mobile URL bar shows/hides
              height: '100dvh'
            }
          }
        }}
      >
        <OverflowMenuContent onClose={close} />
      </Drawer>
    </React.Fragment>
  );
};
